<template>
  <span :class="['label', labelClass]" :style="spanStyle"><slot /></span>
</template>

<script>
import ColourMixin from '@/mixins/colour'

export default {
  name: 'LabelBadge',
  mixins: [ColourMixin],
  props: {
    labelClass: String,
    labelColour: String
  },
  computed: {
    spanStyle() {
      if(this.labelColour) {
        return {
          'background-color': this.labelColour,
          color: this.textColourForBackground(this.labelColour)
        }
      }
      return {}
    }
  },
}
</script>
